import { render, staticRenderFns } from "./Socio-pagamento.vue?vue&type=template&id=428ba528"
import script from "./Socio-pagamento.vue?vue&type=script&lang=js"
export * from "./Socio-pagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-2b047b6fb3/8/home/ilcomi/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports